<div>
  <ocado-home></ocado-home>
  <ejs-toast></ejs-toast>
</div>